import React from "react";
import EditRoute from "../../../../../components/SiteMap/routes/EditRoute";

const SiteMapEditIndex = () => {
  return (
    <>
      <EditRoute />
    </>
  );
};

export default SiteMapEditIndex;
